export default __webpack_public_path__ + "static/media/vol6_1.1ac6bc76.png";